import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PopUpConfirmacionData {
  titulo: string;
  texto: string;
  textoBotonSi: string;
  textoBotonNo: string;
}

@Component({
  selector: 'app-pop-up-confirmacion',
  templateUrl: './pop-up-confirmacion.component.html',
  styleUrls: ['./pop-up-confirmacion.component.css']
})
export class PopUpConfirmacionComponent {
  
  titulo: string;
  texto: string;
  textoBotonSi: string;
  textoBotonNo: string;

  constructor(
    public dialogRef: MatDialogRef<PopUpConfirmacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopUpConfirmacionData
  ) {
    this.titulo = data.titulo || 'Confirmación';
    this.texto = data.texto || '';
    this.textoBotonSi = data.textoBotonSi || 'SI';
    this.textoBotonNo = data.textoBotonNo || 'NO';
  }

  onSi(): void {
    this.dialogRef.close(true);
  }

  onNo(): void {
    this.dialogRef.close(false);
  }

  onClose(): void {
    this.dialogRef.close(null);
  }
}
